import { getArrayOfFilterableBusinessUnits } from '@tracsis/library/lib/helpers';
import { Button } from '@tracsis/library/src';
import cx from 'classnames';
import React from 'react';

import { Search as SearchIcon } from '../Icon';
import * as styles from './CaseStudyFilter.module.css';

const CaseStudyFilter = ({
    action,
    filterQuery,
    businessUnitList,
}: {
    action: string;
    filterQuery: string | undefined;
    businessUnitList?: Array<string>;
}) => {
    return (
        <form
            action={action}
            method="get"
            autoComplete="off"
            className={styles.form}
        >
            <div className={cx(styles.field)}>
                <label htmlFor="businessUnits" className={styles.label}>
                    Filter by Business Unit
                </label>
                <select
                    name="businessUnits"
                    id="businessUnits"
                    aria-label="Business Units"
                    className={styles.input}
                    defaultValue={filterQuery}
                >
                    <option value="all" defaultValue>
                        All
                    </option>
                    {getArrayOfFilterableBusinessUnits().map((businessUnit, i) => {
                        if (businessUnitList && businessUnitList.indexOf(businessUnit.uuid) > -1) {
                            return (
                                <option key={i} value={businessUnit.value}>
                                    {businessUnit.label}
                                </option>
                            )
                        }
                    })}
                </select>
            </div>

            <Button type="submit" aria-label="Submit query" className={styles.button}>
                Search
                <SearchIcon />
            </Button>
        </form>
    );
};

export default CaseStudyFilter;
